import apiClient from "./apiClient"

export type RequestMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH"

interface RequestOptions {
  url: string
  method?: RequestMethod
  data?: any
  params?: Record<string, any>
  headers?: Record<string, string>
  withCredentials?: boolean
  // For endpoints that return a file rather than JSON (e.g. a stored tax-exemption
  // certificate), so the response is not parsed as text.
  responseType?: "blob" | "json" | "text" | "arraybuffer"
}

export const request = async <T = any>({
  url,
  method = "GET",
  data,
  params,
  headers,
  withCredentials,
  responseType,
}: RequestOptions): Promise<T> => {
  const response = await apiClient.request<T>({
    url,
    method,
    data,
    params,
    headers,
    withCredentials,
    responseType,
  })

  return response.data
}
